/* Package Protection row inside the theme's cart drawer (v49).
   Anchors off the CHECKOUT BUTTON. Always sits directly under the subtotal,
   ABOVE the "Track your order" notice: after a re-render the notice could
   land first, so fixOrder() puts protection back above it every pass. */
(function(){
var VARIANT=54131547373915;
var PRICE='';
var busy=false;
var placing=false;
var BASE=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
try{var s=document.createElement('style');s.textContent='cart-drawer [class*="upsell"]{display:none !important;}';document.head.appendChild(s);}catch(e){}
function drawerEl(){return document.querySelector('cart-drawer')||document.querySelector('#CartDrawer')||document.querySelector('[id*="cart-drawer"]');}
function checkoutBtn(root){return root.querySelector('[name="checkout"]')||root.querySelector('a[href*="/checkout"]')||root.querySelector('button[type="submit"]');}
function localPrice(){
var host=document.querySelector('#CartDrawer[data-protection-price]');
if(host&&host.getAttribute('data-protection-price'))return host.getAttribute('data-protection-price');
try{var l=window.IF_LOCAL;if(l&&l.protect){var C=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:C}).format(l.protect/100);}}catch(e){}
return '$2.99';
}
function row(active){
PRICE=localPrice();
var d=document.createElement('div');
d.setAttribute('data-if-protect','1');d.setAttribute('role','checkbox');d.setAttribute('tabindex','0');d.setAttribute('aria-checked',String(active));d.setAttribute('aria-label','Package Protection');
d.setAttribute('style','display:flex !important; align-items:center; gap:12px; border:1.5px solid '+(active?'#12161C':'#DDE3E9')+'; border-radius:12px; padding:12px 14px; margin:0 0 12px; background:'+(active?'#EEF2F5':'#fff')+'; cursor:pointer; font-family:Barlow, sans-serif; text-align:left; width:100%; box-sizing:border-box;');
d.innerHTML='<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#12161C" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M12 2 4 5.5v6c0 4.6 3.2 8.9 8 10.5 4.8-1.6 8-5.9 8-10.5v-6L12 2z"></path><path d="m9 12 2 2 4-4" stroke="#FF4D14"></path></svg>'+
'<div style="flex:1; min-width:0;"><div style="font-weight:800; font-size:14px; color:#12161C; line-height:1.3;">Package Protection <span style="color:#FF4D14;">'+PRICE+'</span></div><div style="font-size:12px; color:#6B7581; line-height:1.4;">Lost, stolen, or buried in a snowbank? We ship a new one free.</div></div>'+
'<div style="width:22px; height:22px; border-radius:5px; flex-shrink:0; display:flex; align-items:center; justify-content:center; border:2px solid '+(active?'#FF4D14':'#C4CBD3')+'; background:'+(active?'#FF4D14':'#fff')+'; color:#fff; font-size:14px; font-weight:800; line-height:1;">'+(active?'&#10003;':'')+'</div>';
return d;
}
function fixOrder(){
var root=drawerEl();if(!root)return;
var node=root.querySelector('[data-if-protect]');if(!node)return;
var par=node.parentNode;if(!par)return;
var kids=[].slice.call(par.children),notice=null;
for(var i=0;i<kids.length;i++){var k=kids[i];if(k===node)continue;if(k.querySelector&&(k.querySelector('[name="checkout"]')||k.querySelector('a[href*="/checkout"]')))continue;if(/Track your order/i.test(k.textContent||'')){notice=k;break;}}
if(notice&&notice.compareDocumentPosition(node)&Node.DOCUMENT_POSITION_FOLLOWING)par.insertBefore(node,notice);
}
function reloadDrawer(){
var host=document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');
if(!host){busy=false;place();return;}
var sid=host.id.replace('shopify-section-','');
fetch(BASE+'?sections='+encodeURIComponent(sid),{headers:{'Accept':'application/json'},credentials:'same-origin'})
.then(function(r){return r.json();})
.then(function(j){var cur=drawerEl();var fresh=new DOMParser().parseFromString(j[sid],'text/html').querySelector('cart-drawer');if(cur&&fresh){cur.innerHTML=fresh.innerHTML;cur.classList.remove('is-empty');}busy=false;place();})
.catch(function(){busy=false;});
}
function toggle(lineKey){
if(busy)return;busy=true;
var control=drawerEl().querySelector('[data-if-protect]');
if(control){control.setAttribute('aria-busy','true');control.style.opacity='0.6';}
var req=lineKey?fetch(BASE+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:lineKey,quantity:0})}):fetch(BASE+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:VARIANT,quantity:1}]})});
req.then(function(r){if(!r.ok)throw new Error('x');return r.json();}).then(reloadDrawer).catch(function(){busy=false;if(control){control.removeAttribute('aria-busy');control.style.opacity='1';}var root=drawerEl();if(root&&!root.querySelector('[data-if-protect-error]')){var error=document.createElement('p');error.setAttribute('data-if-protect-error','');error.setAttribute('role','alert');error.textContent='Could not update package protection. Please try again.';control.insertAdjacentElement('afterend',error);}});
}
function place(){
fixOrder();
if(busy||placing)return;
var root=drawerEl();
if(!root||root.querySelector('[data-if-protect]'))return;
if(!checkoutBtn(root))return;
placing=true;
fetch(BASE+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
.then(function(r){return r.json();})
.then(function(cart){
placing=false;
var root2=drawerEl();
if(!root2||!cart.items.length||root2.querySelector('[data-if-protect]'))return;
var b=checkoutBtn(root2);if(!b)return;
var line=null;
for(var i=0;i<cart.items.length;i++){if(cart.items[i].variant_id===VARIANT){line=cart.items[i];break;}}
var node=row(!!line);
node.addEventListener('keydown',function(ev){if(ev.key===' '||ev.key==='Enter'){ev.preventDefault();node.click();}});
node.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();toggle(line?line.key:null);});
var host=b.closest('form')||b.parentNode;
host.parentNode.insertBefore(node,host);
fixOrder();
}).catch(function(){placing=false;});
}
if(window.MutationObserver){new MutationObserver(function(){place();}).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});}
setInterval(place,700);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',place);}else{place();}
})();
